import { CLEARCUT_FILL_COLOR } from '@rocco/components/image';
import type { FollowSelectorThumbnail } from '../types/follow-selector';

export interface ThumbnailTreatment {
    /** Explicit container fill, when the asset needs one behind it. */
    backgroundColor?: string;
    /** Contain (with padding) instead of cover-cropping. */
    contain: boolean;
    /** Multiply the asset into the neutral fill, matching TileMedia. */
    multiply: boolean;
}

/**
 * How a board thumbnail should sit in its square: clearcut/multiplied assets
 * and background-less professional logos are contained and multiplied over a
 * neutral fill (the TileMedia treatment); photography cover-crops.
 */
export const resolveThumbnailTreatment = (
    thumbnail?: FollowSelectorThumbnail,
): ThumbnailTreatment => {
    const backgroundColor = thumbnail?.backgroundColor;
    const usesNeutralTreatment =
        !!thumbnail?.multiplied ||
        !!thumbnail?.isClearCut ||
        (thumbnail?.type === 'Professional' && !backgroundColor);
    const resolvedBackgroundColor =
        backgroundColor ||
        (usesNeutralTreatment ? CLEARCUT_FILL_COLOR : undefined);

    return {
        backgroundColor: resolvedBackgroundColor,
        contain: !!resolvedBackgroundColor || usesNeutralTreatment,
        multiply: usesNeutralTreatment,
    };
};
